export default __webpack_public_path__ + "static/media/pairing1.3f085756.jpg";